module.exports = __webpack_public_path__ + "static/media/expired-calendar.047b8968.svg";